const browsing = {
  title: "ブラウジング",
  history: "履歴",
  time: {
    now: "たった今",
    minutes: "{{count}}分前",
    hours: "{{count}}時間前",
    days: "{{count}}日前",
    weeks: "{{count}}週間前",
    months: "{{count}}ヶ月前",
    years: "{{count}}年前",
  },
  aiStatus: {
    searching: "検索中",
    analyzing: "分析中",
    reading: "読み込み中",
    thinking: "思考中",
    planning: "リサーチ計画中",
    researching: "リサーチ中",
    reporting: "レポート生成中",
  },
  aiMode: {
    aiModeTooltip: "AIのモデルを選択",
    speed: "速度優先モデル（GPT-4.1 mini）",
    balance: "知能優先モデル（GPT-4.1）",
    intelligent: "推論モデル（o4-mini）",
  },
  mode: {
    llm: "AIチャット",
    llmTooltip: "Tenak AIが自然な言葉で回答",
    web: "WEB検索",
    webTooltip: "URLまたは自動検索を行い、最新の情報に対応した回答",
    youtube: "YOUTUBE検索",
    youtubeTooltip: "YOUTUBEの動画を分析または検索して回答",
    research: "リサーチエージェント",
    researchTooltip:
      "メッセージを分析し、複数のソースを参照してレポートを生成します。履歴に画像が含まれる場合は利用不可。PROモードを利用します。",
  },
  preTitle: "Browsing with",
  subtitle: "Tenak AI はWeb情報を活用し、最新かつ正確な回答を提供します。",
  browsingMode: "WEBアクセス",
  browsingModeDescription: "URLや自動検索を行い、最新の情報に対応した回答を生成します。",
  search: "Search",
  send: "送信 (Ctrl + Enter)",
  pro: "PROモード",
  proTooltip: "PROモードは OPEN AI の推論モデルを使用し、高度な分析を用いた回答を提供します。",
  proDisableTooltip: "画像データを含むチャットスペースではプロモード（推論モデル）は使用できません。",
  searchPlaceholder: "メッセージを入力して下さい。",
  stopGenerating: "生成を停止",
  query: "メッセージ",
  answer: "回答",
  searchMore: "Google でもっと検索する",
  clear: "会話履歴をクリア",
  delete: "チャットを削除",
  customize: "チャットをカスタマイズ",
  new: "NEW",
  displayHistoryDescribe: "30件まで表示されます。",
  noHistory: "会話履歴はありません。",
  addChat: "チャットを追加",
  createChat: "チャットを作成しました。",
  deleteChat: {
    title: "チャットを削除しますか？",
    description: "チャットを削除すると、チャット内のすべてのデータが削除されます。この操作は取り消せません。",
    success: "チャットが削除されました。",
  },
  deleteHistory: {
    title: "会話履歴を削除しますか？",
    description: "会話履歴を削除します。この操作は取り消せません。",
    success: "会話履歴が削除されました。",
  },
  customizeChat: {
    title: "チャットのカスタマイズ",
    description: "チャットのタイトルとTenak AIの振る舞いをカスタマイズできます。",
    chatTitle: "チャットのタイトル",
    chatTitleDescription: "タイトルをメニューに反映します。",
    instructionTitle: "Tenak AI の振る舞い",
    instructionDescription: "役割や回答形式など、Tenak AIの振る舞いをカスタマイズできます。",
    instructionTemplate:
      "# 役割 \n- あなたは優秀なAIアシスタントです。 \n \n# 制約\n- 簡潔に答えてください\n\n# 出力形式\n- 常に日本語で答えよ",
    instructionPlaceholder: "あなたは優秀なAIアシスタントです。",
    setTemplate: "サンプルテンプレートを適用",
    success: "チャットがカスタマイズされました。",
  },
  article: "回答から記事を生成",
  mindMap: "回答からマインドマップを生成",
  summary: "回答を要約",
  attachImage: "画像を添付",
  save: "回答をNotesNebulaに保存",
  error: {
    search: "検索結果が見つからないか、サーバーが高負荷のため検索結果を取得できませんでした。",
  },
  url: {
    title: "参照URL",
    result: {
      success: "URLを参照しました。",
      error: "URLの参照に失敗しました。直接テキストを挿入してください。",
    },
  },
  sidebar: {
    preSearchTitle: "SOURCE",
    preSearchDescription: "WEBアクセスをONにすると、検索結果が表示され、回答の参考にします。",
  },
  caution:
    "* AIは間違った回答をすることがあります。必ず二重チェックをしてください。 * OPEN AIのモデルを使用し、学習には一切使用されません。",
};
export default browsing;
